import { combineEpics } from 'redux-observable';
import toasterEpic from 'shared/toaster/redux/epics';

const getRootEpic = () => {
  const rootEpic = combineEpics(toasterEpic);
  return rootEpic;
};

export default getRootEpic;
